import Vue from 'vue'
import Router from 'vue-router'
// import contact from '@/components/contact/contact'

Vue.use(Router)

const routers = [
  {
    // base: '/new',
    path: '/',
    name: 'home',
    component: () => import('../views/home')
  },
  {
    path: '/introduction',
    name: 'introductions',
    component: () => import('../views/Introduction')
  },
  {
    path: '/contact',
    name: 'contact',
    component: () => import('../views/contact')
  },
  {
    path: '/recruits',
    name: 'recruits',
    component: () => import('../views/recruit')
  },
  {
    path: '/newsInformation',
    name: 'newsInformation',
    component: () => import('../views/newsInformation')
  },
  {
    path: '/product',
    name: 'product',
    component: () => import('../views/product/index'),
    children: [
      {
        path: 'bigData',
        name: 'bigData',
        component: () => import('../views/product/page1')
      },
      {
        path: 'machineVision',
        name: 'machineVision',
        component: () => import('../views/product/page2')
      },
      {
        path: 'medicalAI',
        name: 'medicalAI',
        component: () => import('../views/product/page3')
      },
      {
        path: 'knowledgeGraph',
        name: 'knowledgeGraph',
        component: () => import('../views/product/page4')
      },
      {
        path: 'rulesEngine',
        name: 'rulesEngine',
        component: () => import('../views/product/page5')
      },
      {
        path: 'intelligentDevice',
        name: 'intelligentDevice',
        component: () => import('../views/product/page6')
      },
      {
        path: 'intelligencePlatform',
        name: 'intelligencePlatform',
        component: () => import('../views/product/page7')
      },
      {
        path: 'machineLearning',
        name: 'machineLearning',
        component: () => import('../views/product/page8')
      }
    ]
  }
]
export default routers



// WEBPACK FOOTER //
// ./src/router/index.js